import HTMLText from "./HTMLText";
import Image from "./Image";

export default function Article({ data, header }) {
  const renderElement = (data) => {
    const { type } = data;

    if (type === "text") {
      return <HTMLText content={data.text} />;
    }
    if (type === "image") {
      return <Image src={(data.article_image || {}).url} caption={data.caption} />;
    }
  };

  return (
    <div className="article">
      {header ? <h1>{header}</h1> : null}
      {Array.isArray(data) ? (
        data.map((element, index) => <div key={index}>{renderElement(element)}</div>)
      ) : (
        <HTMLText content={data} />
      )}
    </div>
  );
}
